export enum HeaderTestId {
    UserActions = 'HeaderTestId.UserActions',
    LogOut = 'HeaderTestId.LogOut', // used by E2E tests
    SectionLinkIndicator = 'HeaderTestId.SectionLinkIndicator', // used by integration tests
}
